<template>
<div 
  class = 'rightContent'
  :style = 'applied_styles.assessmentContainer'
  data-name = 'assessment-wrapper'
>
  <!--
  <mu-dialog
    :open='showAssessment'
    dialogClass = 'assessmentDialog'
    bodyClass = 'assessmentDialogBody'
    :scrollable = 'true'
  >
  </mu-dialog>
  -->
  <mu-popover
    :open='showAssessment'
    :trigger = 'popoverAnchor'
    popoverClass = 'assessmentPopover'
    ref='popover'
  >
    <iframe 
      ref = 'container' 
      :src = 'taskUrl'
      :style = 'applied_styles.assessmentFrame'
      allowfullscreen
    >
    </iframe>
  </mu-popover>
</div>
</template>

<script>
import AssessContainerController from './controller';
let controller =new AssessContainerController();
export default controller;
</script>

<style>
.assessmentDialog {
  max-width: unset;
  max-height: unset;
  width: 100vw;
  height: 100vh;
}
.assessmentDialogBody {
  max-width: unset;
  max-height: unset;
  width: 100vw;
  height: 100vh;
}

.assessmentPopover {
  width: 100vw;
  height: 100vh;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}
.mu-popover.assessmentPopover::-webkit-scrollbar {
  height: 0px;
  width: 0px;
}
</style>



// WEBPACK FOOTER //
// component.vue?025b8b0a